import React from "react";

export default function RcvExplanation() {
  return (
    <>
      <p>
        Ranked Choice Voting is superficially similar to STAR, except that
        instead of giving each candidate a score, you rank the candidates
        against one another. A deeper difference is the way the votes are
        tallied.
      </p>
      <h3>How are votes tallied?</h3>
      <p>
        Under RCV, if any candidate is the first choice of more than 50% of the
        voters, they win. Otherwise, the race goes to an "instant runoff." The
        candidate with the fewest votes is eliminated. If that candidate was
        your 1st choice, your vote now goes to your second choice. This process
        continues, with the lowest vote-getters dropped, until one candidate
        acquires more than half of the votes. That candidate wins.
      </p>
      <p>
        Unlike STAR, RCV is subject to{" "}
        <a
          href="https://ballotpedia.org/Ballot_exhaustion"
          target="_blank"
          rel="noopener noreferrer"
        >
          ballot exhaustion
        </a>{" "}
        where some ballots are not counted in the deciding round. It also fails
        the{" "}
        <a
          href="https://electowiki.org/wiki/Monotonicity"
          target="_blank"
          rel="noopener noreferrer"
        >
          monotonicity criterion
        </a>
        , meaning that your vote can backfire, and that ranking a candidate
        higher can hurt them in some cases.
      </p>
      <h3>What's cool about this method?</h3>
      <ul>
        <li>
          Best known of the alternate voting methods and has been most often in
          US elections.
        </li>
        <li>
          Was invented in 1870 and has since been used in multiple democracies
          around the world.
        </li>
      </ul>
      <hr />

      <p className="nextAction">
        Now try it. Pick your favorite candidate, then your second favorite,
        etc. Then click <b>Vote</b>.
      </p>
    </>
  );
}
